import { InteractionType, EventSource, MixpanelEvent, ComponentType } from '../MixPanelTypes';

export type AddWorkerDuplicateSearchEvents =
  | 'SEARCH_RUN'
  | 'MATCH_DETECTED'
  | 'DNR_FLAGGED'
  | 'MARKED_NO_MATCH'
  | 'EXISTING_WORKER_SELECTED'
  | 'DNR_OVERRIDDEN';

export const addWorkerDuplicateSearchEvents: Record<AddWorkerDuplicateSearchEvents, MixpanelEvent> = {
  // System: a duplicate search re-ran off an Add Worker/Engagement smartform field blur.
  SEARCH_RUN: {
    eventDescription: 'Add Worker Duplicate Search Run',
    eventKey: 'add-worker-duplicate-search-run',
    eventSource: EventSource.USER_EFFECT,
    interactionType: InteractionType.N_A,
    componentType: ComponentType.N_A
  },
  // System: a potential match was detected. Broken out by confidence via the XConfidenceCount details.
  MATCH_DETECTED: {
    eventDescription: 'Add Worker Duplicate Search Match Detected',
    eventKey: 'add-worker-duplicate-search-match-detected',
    eventSource: EventSource.SERVER_EVENT,
    interactionType: InteractionType.N_A,
    componentType: ComponentType.N_A
  },
  // System: at least one returned match is flagged as Do Not Rehire (rehire ineligible).
  DNR_FLAGGED: {
    eventDescription: 'Add Worker Duplicate Search DNR Flagged',
    eventKey: 'add-worker-duplicate-search-dnr-flagged',
    eventSource: EventSource.SERVER_EVENT,
    interactionType: InteractionType.N_A,
    componentType: ComponentType.N_A
  },
  // User outcome: reviewer picked "This is a new Worker" (false positive) in the review modal.
  MARKED_NO_MATCH: {
    eventDescription: 'Add Worker Duplicate Search Marked No Match',
    eventKey: 'add-worker-duplicate-search-marked-no-match',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.PRIMARY_ACTION
  },
  // User outcome: reviewer confirmed an existing worker as the match.
  EXISTING_WORKER_SELECTED: {
    eventDescription: 'Add Worker Duplicate Search Existing Worker Selected',
    eventKey: 'add-worker-duplicate-search-existing-worker-selected',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.PRIMARY_ACTION
  },
  // User outcome: reviewer selected an existing worker despite that worker being DNR-flagged.
  DNR_OVERRIDDEN: {
    eventDescription: 'Add Worker Duplicate Search DNR Overridden',
    eventKey: 'add-worker-duplicate-search-dnr-overridden',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.PRIMARY_ACTION
  }
} as const;
